import React, { Component } from "react";
import './displaySchema.css'

class FoldoutCP extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isOpen: props.isOpen || false
    }
  }

  _onClick (event, isOpen) {
    this.setState({isOpen})
    if (this.props.onClick) this.props.onClick(event, isOpen)
  }

  render () {
    //let isOpen = this.props.isOpen ?? this.state.isOpen // allows for render prop override for outside control
    let isOpen = this.state.isOpen// ?? this.state.isOpen // allows for render prop override for outside control
    return (
      <>
        <div className='dsHeader'>
          <div className='dsHeaderClickable' onClick={event => this._onClick(event, !isOpen)}
        >{this.props.displayName} {isOpen ? '[-]' : '[+]'}</div></div>
          <div className='dsIndent'>
            {isOpen
              ? this.props.children
              : <div className='dsCollapsedPlaceholder'
                onClick={event => this._onClick(event, !isOpen)}>...</div>
            }
          </div>
        <div className='dsFooter'></div>
      </>
    )
  }
}

export default FoldoutCP
